import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';

import { useSelector } from 'app/store';
import { linksLinkMaxMcsSelector } from 'modules/links/slice';

import MCSChart, { MCSChartProps } from '../components/elements/MCSChart';

const MCSChartContainer = (props: Partial<MCSChartProps>) => {
  const { linkId } = useBottomPanel();

  const maxMcs = useSelector((state) => (linkId ? linksLinkMaxMcsSelector(state, linkId) : undefined));

  if (maxMcs == null) {
    return null;
  }

  const valueCount = maxMcs + 1;

  return <MCSChart valueCount={valueCount} {...props} />;
};

export default MCSChartContainer;
